export const pageTitleBase = 'Legitimare AR';
